module.exports = __webpack_public_path__ + "votolegal-icon--111ae335.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/icons/votolegal-icon.jpg
// module id = 32
// module chunks = 0